import { Select } from 'antd';
import { Switch } from 'antd/lib';
import React from 'react';
import { BooleanVariableModel } from '../../iasConfigSchema';
import VariableFormItem from '../variables/VariableFormItem';

const BooleanWidget: React.FC<{
  variable: BooleanVariableModel;
  disabled: boolean;
}> = ({ variable, disabled }) => {
  return (
    <VariableFormItem variable={variable}>
      {variable.default !== undefined ? (
        <Switch disabled={disabled} />
      ) : (
        <Select disabled={disabled}>
          <Select.Option key={'true'} value={true}>
            True
          </Select.Option>
          <Select.Option key={'false'} value={false}>
            False
          </Select.Option>
        </Select>
      )}
    </VariableFormItem>
  );
};

export default BooleanWidget;
